import { Progress } from '@/components/ui/progress';
import { X } from 'lucide-react';
import { Typography } from '../typography';
import Icons from '@/const/icons';
import { Icon } from '../icon';

interface Props {
	isShowPrevFile: boolean;
	percent: number;
	fileName: string;
	handleRemove: () => void;
	// handleDeleteFile: () => void;
}

export const ProgressBarBox: React.FC<Props> = ({
	isShowPrevFile,
	percent,
	fileName,
	handleRemove,
}) => {
	return (
		<div className="bg-gray-5 rounded-xl py-1 px-3 min-h-9 flex items-center gap-3">
			<div>
				<Icon
					src={Icons.documentUpload}
					className="text-purple-150 !w-5 !h-5"
				/>
			</div>
			{percent !== 100 && !fileName && !isShowPrevFile && (
				<Progress
					value={percent}
					aria-label="Upload progress"
					aria-valuenow={percent}
					classNameRoot="bg-white !h-2.5"
					classNameIndicator="bg-main-blue"
				/>
			)}
			{(percent === 100 || fileName || isShowPrevFile) && (
				<Typography
					type="regular-10"
					text={fileName}
					className="opacity-60 line-clamp-1 w-full"
				/>
			)}

			{!isShowPrevFile && fileName && (
				<button
					type="button"
					onClick={handleRemove}
					aria-label={`Remove ${fileName}`}
					className="rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
				>
					<X className="!w-5 !h-5" />
				</button>
			)}
		</div>
	);
};
